import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import pig1 from '../../assets/graphics/pig1.gif';
import { MainRoutes } from '../../shared/models';

export const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="min-h-screen flex flex-col items-center justify-center bg-background px-6 py-12 animate-fade-in">
      <div className="bg-card border-2 border-border/50 rounded-3xl p-8 md:p-12 shadow-lg text-center max-w-lg">
        {/* 404 number */}
        <h1 className="text-8xl md:text-9xl font-bold text-primary/20 mb-4">
          404
        </h1>

        {/* Pig gif */}
        <div className="flex justify-center mb-6">
          <img
            src={pig1}
            alt="Gruntled mascot"
            className="w-48 h-48 md:w-60 md:h-60 object-contain"
          />
        </div>

        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-4">
          {t('notFound.title')}
        </h2>

        {/* Description */}
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">
          {t('notFound.description')}
        </p>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-secondary text-secondary-foreground font-medium rounded-full hover:bg-secondary/80 transition-colors"
          >
            {t('common.goBack')}
          </button>
          <button
            onClick={() => navigate(MainRoutes.Landing)}
            className="px-6 py-3 bg-primary text-primary-foreground font-medium rounded-full hover:bg-primary/90 transition-colors flex items-center justify-center gap-2"
          >
            <span>{t('notFound.goHome')}</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};
